import EmptyBhPage from './EmptyBhPage';

export default EmptyBhPage;
